import React from 'react'
import { createIconComponent } from '../Icon'

const OutlinedLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m760-600-50-110-110-50 110-50 50-110 50 110 110 50-110 50-50 110Zm0 560-50-110-110-50 110-50 50-110 50 110 110 50-110 50-50 110ZM360-160 260-380 40-480l220-100 100-220 100 220 220 100-220 100-100 220Zm0-194 40-86 86-40-86-40-40-86-40 86-86 40 86 40 40 86Zm0-126Z"/></svg>
)

const OutlinedSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M723.999-593.155 678.691-692l-98.845-44.307 98.845-45.307 45.308-98.845 44.307 98.845 98.845 45.307L768.306-692l-44.307 98.845Zm0 512.614-44.308-99.845-99.845-44.307L679.691-269l44.308-99.845L768.306-269l99.845 44.307-99.845 44.307-44.307 99.845ZM355.384-217.465 273.77-399.386 91.85-481l181.92-81.614 81.614-181.921 81.615 181.921L618.919-481l-181.92 81.614-81.615 181.921Zm0-125.535 43-95 95-43-95-43-43-95-43 95-95 43 95 43 43 95Zm-6-137Z"/></svg>
)

const FilledLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m760-600-50-110-110-50 110-50 50-110 50 110 110 50-110 50-50 110Zm0 560-50-110-110-50 110-50 50-110 50 110 110 50-110 50-50 110ZM360-160 260-380 40-480l220-100 100-220 100 220 220 100-220 100-100 220Z"/></svg>
)

const FilledSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M723.999-593.155 678.691-692l-98.845-44.307 98.845-45.307 45.308-98.845 44.307 98.845 98.845 45.307L768.306-692l-44.307 98.845Zm0 512.614-44.308-99.845-99.845-44.307L679.691-269l44.308-99.845L768.306-269l99.845 44.307-99.845 44.307-44.307 99.845ZM355.384-217.465 273.77-399.386 91.85-481l181.92-81.614 81.614-181.921 81.615 181.921L618.919-481l-181.92 81.614-81.615 181.921Z"/></svg>
)

export const AutoAwesomeIcon = createIconComponent({
  OutlinedLarge,
  OutlinedSmall,
  FilledLarge,
  FilledSmall,
})
